import { render, staticRenderFns } from "./PostFormContactInfoBV.vue?vue&type=template&id=fc30c234&scoped=true&"
import script from "./PostFormContactInfoBV.vue?vue&type=script&lang=js&"
export * from "./PostFormContactInfoBV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc30c234",
  null
  
)

export default component.exports